import React from 'react';

import { debounce } from 'throttle-debounce';

import { isArrayEmpty } from 'helpers/ArrayHelpers';
import { useAnalytics } from 'hooks/useAnalytics';

import type { IAnalyticsListProps, IProduct } from 'types';

// TODO: fix promotion type

export function useAnalyticsViewItemList(
  products: IProduct[] | undefined,
  listProps: IAnalyticsListProps,
  options?: { enabled?: boolean, promotion?: { code: string, name: string } }
) {

  // Refs

  const triggeredRef = React.useRef(false);
  const debouncedHandlerRef = React.useRef(null);

  // Hooks

  const analytics = useAnalytics();

  // Props

  const { enabled, promotion } = options || {};

  // Handlers

  const onItemListViewed = React.useCallback((
    currentProducts: IProduct[],
    currentListProps: IAnalyticsListProps,
    currentPromotion: { code: string, name: string }
  ) => {
    const { analyticsListId: id, analyticsListName: name } = currentListProps || {};
    analytics.viewItemList(currentProducts, { id, name }, currentPromotion);
    triggeredRef.current = true;
  }, []);

  debouncedHandlerRef.current = React.useMemo(() => {
    return debounce(250, onItemListViewed);
  }, []);

  // Effects

  React.useEffect(() => {
    if (!enabled || triggeredRef.current) {
      return;
    }
    if (products && !isArrayEmpty(products)) {
      debouncedHandlerRef.current(products, listProps, promotion);
    }
  }, [enabled, products, listProps, promotion]);
}
